import { createTheme } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface Palette {
    tertiary: Palette['primary']
    quaternary: Palette['primary']

    starColor: {
      gold: string
      grey: string
    }

    blue: {
      50: string
      100: string
      200: string
      800: string
      900: string
    }
  }

  interface PaletteOptions {
    tertiary?: PaletteOptions['primary']
    quaternary?: PaletteOptions['primary']

    starColor?: {
      gold: string
      grey: string
    }

    blue: {
      50: string
      100: string
      200: string
      800: string
      900: string
    }
  }
}

const theme = createTheme({
  typography: {
    fontFamily: 'DM Sans, sans-serif'
  },

  palette: {
    primary: {
      main: '#6D28D9',
      light: '#9F7AEA',
      dark: '#381E72',
      contrastText: '#fff'
    },

    secondary: {
      main: '#339FFF',
      light: '#66C2FF',
      dark: '#0077C8',
      contrastText: '#fff'
    },

    tertiary: {
      main: '#F5F3FF',
      contrastText: '#6D28D9'
    },

    quaternary: {
      main: '#F5F3FF',
      contrastText: '#6D28D9'
    },

    grey: {
      50: '#F9FAFB',
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D1D5DB',
      400: '#9CA3AF',
      500: '#6B7280',
      600: '#4B5563',
      700: '#374151',
      800: '#1F2937'
    },

    error: {
      main: '#FF0000'
    },

    success: {
      main: '#10B981',
      light: '#3FC79A',
      dark: '#0B815A',
      contrastText: '#fff'
    },

    warning: {
      main: '#F59E0B',
      light: '#FDE68A',
      dark: '#EAB308',
      contrastText: '#9A3412'
    },

    info: {
      main: '#339FFF',
      light: '#66C2FF',
      dark: '#0077C8',
      contrastText: '#fff'
    },

    starColor: {
      gold: '#F59E0B',
      grey: '#D1D5DB'
    },

    blue: {
      50: '#EFF6FF',
      100: '#CDDEED',
      200: '#BFDBFE',
      800: '#1F6AAD',
      900: '#1A5A94'
    }
  },

  shape: {
    borderRadius: 8
  },

  components: {
    // Mobile Safari (and some Android browsers) zoom the viewport when a focused
    // control’s font size is under 16px. Keep inputs at 16px on small screens only.
    MuiInputBase: {
      styleOverrides: {
        root: ({ theme }) => ({
          [theme.breakpoints.down('md')]: {
            fontSize: '16px'
          }
        }),
        input: ({ theme }) => ({
          [theme.breakpoints.down('md')]: {
            fontSize: '16px'
          }
        })
      }
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#D1D5DB'
            },
            '&:hover fieldset': {
              borderColor: '#9CA3AF'
            },
            '&.Mui-focused fieldset': {
              borderColor: '#6D28D9'
            }
          }
        }
      }
    },

    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#1F2937'
        }
      }
    }
  }
})

export default theme
